import React, { useEffect, useState, useImperativeHandle } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal, Steps, Button, message } from 'antd';
import Steps1 from './steps/steps1';
import Steps2 from './steps/steps2';
import Steps3 from './steps/steps3';
import { addProject, editProject } from '../../../actions/majorProjects';
import basicInfo from '../images/basicInfo.png';
import platform from '../images/platform.png';
import finish from '../images/finish.png';

const { Step } = Steps


const AddOrUpdate = (props) => {

    const [current, setCurrent] = useState(0);
    const [visible, setVisible] = useState(false);
    const [defaultGroup, setDefaultGroup] = useState('');

    useEffect(() => {
    },[props])

    useImperativeHandle(props.refs, () => ({
        changeAddModalVisible: changeAddModalVisible
    }))

    const changeAddModalVisible = (visible) => {
        setVisible(visible);
    }

    const steps = [
        {
            title: '基本信息',
            content: <Steps1 />,
            selectedIcon: <div className="steps-selected"><img src={basicInfo} alt="" /></div>,
            unSelectedIcon: <div className="steps-unselected"><img src={basicInfo} alt=""/></div>,
            left: '70px',
        },
        // {
        //     title: '拟发平台',
        //     content: <Steps2 />,
        //     selectedIcon: <div className="steps-selected"><img src={platform} alt="" /></div>,
        //     unSelectedIcon: <div className="steps-unselected"><img src={platform} alt=""/></div>,
        //     left: '50%'
        // },
        {
            title: '完成',
            content: <Steps3 />,
            selectedIcon: <div className="steps-selected"><img src={finish} alt="" /></div>,
            unSelectedIcon: <div className="steps-unselected"><img src={finish} alt=""/></div>,
            left: 'calc( 100% - 70px)'
        },
    
    ]

    const handleCancel = () => {
        changeAddModalVisible(false);
        // props.changeModalVisible(false)
        //清空redux中的所有数据
        props.resetData();  
        setCurrent(0);
        props.search(1,props.params);
    }

    const handleOk = () => {
        props.changeModalVisible(false);
    }

    const next = () => {
        const lCurrent = current;
        let projectAttachment = props.projectAttachment.map((item) => item.resourceId)
        let params = {
            name: props.projectName.trim(),
            manager: props.projectCreater.trim(),
            content: props.projectContent.trim(),
            // mediaIds: mediaIds.join(','),
            fileIdsStr: projectAttachment.join(','),  
            type: 2
        }
        window.loading.show()
        if(props.modalTitle === '新增项目'){
            addProject(params, function(res){
                window.loading.hide()
                if(res){
                    setCurrent(lCurrent + 1);
                }
            })
        }  
        if(props.modalTitle === '编辑项目'){
            editProject({...params, id: props.item.id}, function(res){
                window.loading.hide()
                if(res){
                    setCurrent(lCurrent + 1);
                }
            })
        } 
        
    }

    const prev = () => {
        const lCurrent = current;
        setCurrent(lCurrent - 1);
    }

    const steps1next = () => {
        //在第一步中点击了下一步
        const { projectName, projectContent  } = props;
        if(projectName.trim() === ''){
            message.error('请先输入项目名称！');
            return;
        }
        if(projectContent.trim() === ''){
            message.error('请先输入项目内容！');
            return;
        }
        next();
    }


    const steps2next = () => {
        //在第二步中点击了下一步
        //获取redux中的数据，判断是否选择了拟发平台
        //(1)未选择：message.error('请至少选择一个拟发平台！'); 
        //(2)已选择： 发送add  edit请求   请求成功跳转到第三步  next();
                     //请求失败则停留在第二步，不进行跳转
        if(props.platform.length === 0 ){
            message.error('请至少选择一个拟发平台！');
            return;
        }
        else {
            let mediaIds = props.platform.map((item) => item.id)
            let projectAttachment = props.projectAttachment.map((item) => item.resourceId)
            let params = {
                name: props.projectName.trim(),
                manager: props.projectCreater.trim(),
                content: props.projectContent.trim(),
                mediaIds: mediaIds.join(','),
                fileIdsStr: projectAttachment.join(','),  
                type: 2
            }
            window.loading.show()
            if(props.modalTitle === '新增项目'){
                addProject(params, function(res){
                    window.loading.hide()
                    if(res){
                        next();
                    }
                })
            }  
            if(props.modalTitle === '编辑项目'){
                editProject({...params, id: props.item.id}, function(res){
                    window.loading.hide()
                    if(res){
                        next()
                    }
                })
            } 
        }
    }

    const steps3next = () => {
        props.resetData();
        setCurrent(0);
        if(props.modalTitle === '编辑项目'){
            props.changeModalTitle('新增项目')
        }
    }

    const renderFooter = (currentStep) => {
        switch (currentStep) {
            case 0: return <>
                            <Button style={{ marginRight: 8 }} onClick={handleCancel}>取消</Button>
                            <div className="next" onClick={steps1next}>提交</div>
                          </>;
            // case 1: return <>
            //                 <Button style={{ marginRight: 8 }} onClick={prev}>上一步</Button>
            //                 <div className="next" onClick={steps2next}>下一步</div>  
            //                </>;
            case 1: return <>
                            <div className="next continue"  onClick={steps3next}>{ '继续创建' }</div>
                            <Button onClick={handleCancel}>关闭</Button>
                           </>;
            default: break;
        }
    }

    return (
        <Modal
            className="projects-edit-modal"
            width='70%'
            title={props.modalTitle}
            visible={visible}
            onCancel={handleCancel}
            onOk={handleOk}
            destroyOnClose
            footer={null}>
            <Steps current={current} style={{ padding: '0 30px'}}>
                {
                    steps.map((item, index) => (
                        <Step key={item.title} title={item.title} icon={ current >= index ? item.selectedIcon : item.unSelectedIcon } current={current} ></Step>
                    ))
                }
            </Steps>
            <div className="line"><div className="triangle" style={{ left: steps[current].left}}></div></div>
            <div className="content">{steps[current].content}</div>
            <div className="footer">
                {renderFooter(current)}
            </div>
        </Modal>
    )
}

AddOrUpdate.propTypes = {
    visible: PropTypes.bool,
    changeModalVisible: PropTypes.func,
}

const mapStateToProps = (state) => {
    return{
        modalTitle: state.projectReducer.modalTitle,
        projectName: state.projectReducer.projectName,
        projectCreater: state.projectReducer.projectCreater,
        projectContent: state.projectReducer.projectContent,
        projectAttachment: state.projectReducer.projectAttachment,
        platform: state.projectReducer.platform
    }
}

const mapDispatchToProps = (dispatch) => {

    return{
        changeModalTitle: (value) => dispatch({type: 'CHANGE_MODAL_TITLE', payload: value}),
        resetData: () => dispatch({ type: 'RESET_DATA'})

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddOrUpdate);